function genericdfs(
  graph,
  cb,
  donecb = () => false,
  level = 0,
  postTraversal = false
) {
  const children = graph.children || [];
  if (!postTraversal) cb(graph, level);
  for (let child of children)
    genericdfs(child, cb, () => false, level + 1, postTraversal);
  if (postTraversal) cb(graph, level);
  donecb();
}

export default genericdfs;
